enum TerminusType {
  YoungAndInGoodHealth,
  NotGoingToTakePensionSoon,
  PlanningToLeaveUK,
  TransferValueTooLow
}

export default TerminusType;
